// src/pages/CompanyAdminDashboard.js
import React from 'react';
import DashboardShell from '../components/dashboard/DashboardShell';
import CompanyDashboardView from '../components/dashboard/companyadmin/CompanyDashboardView';
import { getUser } from '../utils/auth';

function CompanyAdminDashboard() {
  const user = getUser();

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="Company overview">
      <CompanyDashboardView />
    </DashboardShell>
  );
}

export default CompanyAdminDashboard;
